// extracted by mini-css-extract-plugin
module.exports =  {"container":"_2787e5dfdf--container--KKnnx"};